import { getConsulData } from 'UtilityComponents/index';

const consulData = getConsulData('config').FREQUENCY || {};

export const { WEEK_DAYS, WeekDayfield, MonthField, DayField, DailyField, WeekField } = consulData;
